import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { PhoneCall } from "lucide-react";
import { ContactRegistration } from "@/components/ContactRegistration";

export const RegistraContattoDialog = ({ trigger, defaultPersonId = null, onDone }) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button className="bg-[color:var(--brand-orange-600)] hover:bg-[color:var(--brand-orange-500)] text-white" data-testid="registra-contatto-button">
            <PhoneCall className="h-4 w-4 mr-2" /> Registra contatto
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-3xl max-h-[92vh] overflow-auto ras-scroll">
        <DialogHeader><DialogTitle className="font-display">Registra contatto</DialogTitle></DialogHeader>
        <ContactRegistration defaultPersonId={defaultPersonId} onDone={(d) => { setOpen(false); onDone && onDone(d); }} />
      </DialogContent>
    </Dialog>
  );
};
